(() => {
  if (window.__CVGFSalesAssistantLoaded) return;
  window.__CVGFSalesAssistantLoaded = true;

  const script = document.currentScript;
  const apiBase = (script && script.dataset.apiBase) || (script ? new URL(script.src).origin : "");
  const chatUrl = apiBase + "/api/public/website-sales/chat";
  const eventUrl = apiBase + "/api/public/website-sales/event";
  const storageKey = "cvgf_sales_session";
  const sessionKey = localStorage.getItem(storageKey) || (crypto.randomUUID ? crypto.randomUUID() : "web-" + Date.now() + "-" + Math.random().toString(16).slice(2));
  localStorage.setItem(storageKey, sessionKey);

  let product = null;
  let open = false;
  let busy = false;

  const style = document.createElement("style");
  style.textContent = `
    #cvgf-sa-root{font-family:Arial,Helvetica,sans-serif;color:#173b2d;position:fixed;z-index:2147483000;right:18px;bottom:18px}
    #cvgf-sa-launch{border:0;border-radius:999px;background:#173b2d;color:#fff;padding:14px 18px;font-weight:800;font-size:14px;box-shadow:0 8px 28px rgba(0,0,0,.22);cursor:pointer}
    #cvgf-sa-nudge{position:absolute;right:0;bottom:62px;width:min(330px,calc(100vw - 36px));background:#fff;border:1px solid #d9e4de;border-radius:15px;padding:13px 15px;box-shadow:0 12px 35px rgba(0,0,0,.16);font-size:14px;line-height:1.42}
    #cvgf-sa-panel{display:none;position:absolute;right:0;bottom:0;width:min(390px,calc(100vw - 24px));height:min(650px,calc(100vh - 40px));background:#fff;border:1px solid #d9e4de;border-radius:18px;overflow:hidden;box-shadow:0 18px 48px rgba(0,0,0,.24)}
    #cvgf-sa-panel.open{display:flex;flex-direction:column}
    #cvgf-sa-head{background:#173b2d;color:#fff;padding:15px 16px;display:flex;align-items:center;justify-content:space-between}
    #cvgf-sa-head strong{font-size:15px} #cvgf-sa-head span{display:block;font-size:11px;opacity:.78;margin-top:2px}
    #cvgf-sa-close{border:0;background:transparent;color:#fff;font-size:24px;cursor:pointer;line-height:1}
    #cvgf-sa-messages{flex:1;overflow:auto;background:#f6f8f6;padding:15px}
    .cvgf-sa-msg{max-width:84%;padding:10px 12px;border-radius:14px;margin:0 0 9px;font-size:14px;line-height:1.42;white-space:pre-wrap}
    .cvgf-sa-bot{background:#fff;border:1px solid #e1e8e4;border-bottom-left-radius:5px}
    .cvgf-sa-user{background:#dcecdf;margin-left:auto;border-bottom-right-radius:5px}
    .cvgf-sa-actions{display:flex;gap:8px;flex-wrap:wrap;margin:7px 0 12px}
    .cvgf-sa-action{border:1px solid #173b2d;border-radius:999px;background:#fff;color:#173b2d;padding:8px 11px;font-weight:800;font-size:12px;cursor:pointer}
    .cvgf-sa-products{display:grid;gap:9px;margin:4px 0 12px}
    .cvgf-sa-product{display:block;text-decoration:none;color:#173b2d;background:#fff;border:1px solid #dce5df;border-radius:13px;padding:11px 12px;box-shadow:0 2px 8px rgba(0,0,0,.04)}
    .cvgf-sa-product:hover{border-color:#173b2d}
    .cvgf-sa-product-title{font-weight:800;font-size:13px;line-height:1.25}
    .cvgf-sa-product-meta{margin-top:4px;font-size:11px;color:#65736c}
    .cvgf-sa-product-cta{margin-top:7px;font-weight:800;font-size:11px;text-decoration:underline}
    #cvgf-sa-form{display:flex;gap:8px;padding:12px;background:#fff;border-top:1px solid #e1e8e4}
    #cvgf-sa-input{flex:1;min-width:0;border:1px solid #c8d5ce;border-radius:12px;padding:11px 12px;font-size:14px;outline:none}
    #cvgf-sa-send{border:0;border-radius:12px;background:#173b2d;color:#fff;padding:0 14px;font-weight:800;cursor:pointer}
    #cvgf-sa-send:disabled{opacity:.45;cursor:default}
    #cvgf-sa-note{padding:0 12px 10px;background:#fff;color:#708078;font-size:10px;text-align:center}
    @media(max-width:520px){#cvgf-sa-root{right:10px;bottom:10px}#cvgf-sa-panel{position:fixed;inset:8px;width:auto;height:auto;border-radius:16px}}
  `;
  document.head.appendChild(style);

  const root = document.createElement("div");
  root.id = "cvgf-sa-root";
  root.innerHTML = `
    <div id="cvgf-sa-nudge" hidden></div>
    <button id="cvgf-sa-launch" type="button" aria-label="Open product help">Need some advice?</button>
    <section id="cvgf-sa-panel" role="dialog" aria-label="CVGF product specialist">
      <header id="cvgf-sa-head"><div><strong>CVGF Product Specialist</strong><span>Online product assistant</span></div><button id="cvgf-sa-close" type="button" aria-label="Close">×</button></header>
      <div id="cvgf-sa-messages"></div>
      <form id="cvgf-sa-form"><input id="cvgf-sa-input" autocomplete="off" placeholder="Ask me anything about this product…" maxlength="2000"><button id="cvgf-sa-send" type="submit">Send</button></form>
      <div id="cvgf-sa-note">I use CVGF product information. If I’m not certain, I’ll say so and get the team to confirm.</div>
    </section>
  `;
  document.body.appendChild(root);

  const $ = (id) => document.getElementById(id);
  const panel = $("cvgf-sa-panel");
  const launch = $("cvgf-sa-launch");
  const closeBtn = $("cvgf-sa-close");
  const messages = $("cvgf-sa-messages");
  const form = $("cvgf-sa-form");
  const input = $("cvgf-sa-input");
  const send = $("cvgf-sa-send");
  const nudge = $("cvgf-sa-nudge");

  function text(value) { return String(value || "").trim(); }
  function money(value) { const n = Number(value); return Number.isFinite(n) ? n / 100 : null; }
  function productHandle() {
    const match = location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }
  async function loadProduct() {
    const handle = productHandle();
    if (!handle) return null;
    try {
      const response = await fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } });
      if (!response.ok) return null;
      const data = await response.json();
      const variant = data.variants && data.variants.find(v => v.available) || data.variants && data.variants[0] || null;
      return {
        type: "product",
        title: text(data.title),
        handle: text(data.handle || handle),
        sku: text(variant && variant.sku),
        variantId: variant && variant.id ? String(variant.id) : "",
        price: variant ? money(variant.price) : null
      };
    } catch { return null; }
  }
  function pageContext() {
    return {
      url: location.href.slice(0, 500),
      title: document.title.slice(0, 180),
      type: product ? "product" : "page",
      handle: product && product.handle || "",
      sku: product && product.sku || "",
      variantId: product && product.variantId || "",
      price: product && product.price
    };
  }
  function addMessage(role, content) {
    const el = document.createElement("div");
    el.className = "cvgf-sa-msg " + (role === "user" ? "cvgf-sa-user" : "cvgf-sa-bot");
    el.textContent = content;
    messages.appendChild(el);
    messages.scrollTop = messages.scrollHeight;
    return el;
  }
  function addProductCards(data) {
    const products = data && Array.isArray(data.products) ? data.products : [];
    if (!products.length) return;
    const wrap = document.createElement("div");
    wrap.className = "cvgf-sa-products";
    products.slice(0, 4).forEach((item) => {
      if (!item || !item.url || !item.title) return;
      const link = document.createElement("a");
      link.className = "cvgf-sa-product";
      link.href = item.url;
      link.target = "_self";
      link.rel = "noopener";
      const title = document.createElement("div");
      title.className = "cvgf-sa-product-title";
      title.textContent = item.title;
      const meta = document.createElement("div");
      meta.className = "cvgf-sa-product-meta";
      const bits = [];
      if (item.sku) bits.push(item.sku);
      if (item.variantTitle && item.variantTitle !== "Default Title") bits.push(item.variantTitle);
      if (Number.isFinite(Number(item.price))) bits.push("£" + Number(item.price).toFixed(2));
      meta.textContent = bits.join(" · ");
      const cta = document.createElement("div");
      cta.className = "cvgf-sa-product-cta";
      cta.textContent = "View product →";
      link.appendChild(title);
      if (meta.textContent) link.appendChild(meta);
      link.appendChild(cta);
      link.addEventListener("click", () => {
        track("product_link_clicked", Number(item.price), {
          recommendedSku: item.sku || null,
          recommendedHandle: item.handle || null,
          recommendedUrl: item.url
        });
      });
      wrap.appendChild(link);
    });
    if (wrap.childElementCount) {
      messages.appendChild(wrap);
      messages.scrollTop = messages.scrollHeight;
    }
  }

  function addActions(data) {
    if (!data || data.action === "none") return;
    const row = document.createElement("div");
    row.className = "cvgf-sa-actions";
    const button = document.createElement("button");
    button.type = "button";
    button.className = "cvgf-sa-action";
    button.textContent = data.ctaLabel || (data.action === "add_current_to_cart" ? "Add to basket" : "Ask the team");
    button.addEventListener("click", async () => {
      if (data.action === "add_current_to_cart" && product && product.variantId) {
        button.disabled = true;
        const r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: Number(product.variantId), quantity: 1 }) });
        if (r.ok) {
          addMessage("assistant", "Done — I’ve added it to your basket.");
          track("add_to_cart", product.price || null);
          button.textContent = "Added";
        } else {
          addMessage("assistant", "I couldn’t add that automatically. You can still use the normal Add to cart button on the page.");
          button.disabled = false;
        }
      } else {
        addMessage("assistant", "No problem. Pop your name, email or phone number in your next message and tell me the best way for the team to contact you.");
        input.focus();
        track("handoff_requested");
      }
    });
    row.appendChild(button);
    messages.appendChild(row);
    messages.scrollTop = messages.scrollHeight;
  }
  async function track(eventType, value, extraMetadata) {
    try {
      await fetch(eventUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionKey, eventType, sku: product && product.sku, handle: product && product.handle, value, metadata: Object.assign({ page: location.pathname }, extraMetadata || {}) }),
        keepalive: true
      });
    } catch {}
  }
  function openPanel() {
    open = true;
    panel.classList.add("open");
    launch.style.display = "none";
    nudge.hidden = true;
    input.focus();
    track("chat_opened");
  }
  function closePanel() {
    open = false;
    panel.classList.remove("open");
    launch.style.display = "";
  }
  async function sendMessage(message) {
    if (busy || !message) return;
    busy = true;
    send.disabled = true;
    addMessage("user", message);
    input.value = "";
    const thinking = addMessage("assistant", "Just checking that for you…");
    try {
      const response = await fetch(chatUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionKey, message, page: pageContext() })
      });
      const data = await response.json();
      thinking.remove();
      addMessage("assistant", data.reply || "I’ve hit a snag there. I’d rather get the team to confirm than guess.");
      addProductCards(data);
      addActions(data);
      if (data.needsHandoff) track("knowledge_gap");
    } catch {
      thinking.remove();
      addMessage("assistant", "I’ve hit a snag there. I don’t want to guess, so I’d rather get the team to confirm that for you.");
    } finally {
      busy = false;
      send.disabled = false;
      input.focus();
    }
  }

  launch.addEventListener("click", openPanel);
  closeBtn.addEventListener("click", closePanel);
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    sendMessage(text(input.value));
  });

  (async () => {
    product = await loadProduct();
    const greeting = product
      ? `Hi, you alright? 👋 Need any help with the ${product.title || "product"}? Have you got a space in mind for it?`
      : "Hi, you alright? 👋 Need any help finding the right thing for your garden?";
    addMessage("assistant", greeting);
    nudge.textContent = greeting;
    setTimeout(() => { if (!open && !sessionStorage.getItem("cvgf_sa_nudged")) { nudge.hidden = false; sessionStorage.setItem("cvgf_sa_nudged", "1"); } }, 6500);
    track("widget_loaded");
  })();
})();